import styled from 'styled-components';

import Input from 'components/commons/Input';

import {
  fontFamilyPrimary,
  colorBlack900,
  colorWhite,
  colorPrimaryLighten95,
  colorAccent,
  mediaQueryMobileLargeMin,
} from 'styles';

export const Select = styled.button`
  position: relative;
  border: none;
  background: none;
  font-size: 14px;
  font-family: ${fontFamilyPrimary};
  line-height: 24px;
  color: ${colorBlack900};

  svg {
    fill: ${colorAccent};
  }

  ${({ isOpen }) =>
    isOpen &&
    ` 
  color: ${colorAccent};
`}
`;

export const OutlinedSelect = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  align-self: unset;
  margin-top: 8px;
  margin-bottom: 15px;
  background: ${colorWhite};
  outline: 0;
  min-width: 190px;
  height: 40px;
  padding: 8px 15px;
  border: 1px solid #cacccb;
  box-sizing: border-box;
  border-radius: 2px;
  color: ${colorBlack900};

  /* stylelint-disable */
  & > svg {
    /* stylelint-enable */
    display: block;
    margin-top: -2px;
    fill: black;
    pointer-events: none;

    transform: rotate(0deg);
  }

  &:hover {
    border: 1px solid #87928c;
  }
`;

export const CloseButton = styled.button`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  border: none;
  outline: none;
  background-color: transparent;

  @media all and ${mediaQueryMobileLargeMin} {
    display: none;
  }
`;

export const DropdownListWrapper = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  min-width: 340px;
  max-width: 100%;
  background: ${colorWhite};
  z-index: 3000000000;
  overflow: auto;

  @media all and ${mediaQueryMobileLargeMin} {
    position: absolute;
    height: 376px;
    top: calc(50% + 16px);
    bottom: unset;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.14);
  }

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const DropdownListHeader = styled.div`
  margin-bottom: 9px;
`;

export const DropdownContent = styled.div``;

export const DropdownContentList = styled.ul``;

export const DropdownItem = styled.li`
  display: flex;
  padding: 8px 12px;
  text-align: left;
  align-items: center;
  ${({ isActive }) =>
    isActive &&
    ` 
    background: #CFE9E0;
    `}

  &:hover {
    cursor: pointer;
    background: #f3faf7;
  }
`;

export const DropdownLink = styled.a`
  display: block;
  width: 100%;
  color: ${colorBlack900};
`;

export const DropdownName = styled.span`
  display: block;
  font-size: 16px;
  line-height: 24px;
  color: ${colorBlack900};
`;

export const DesktopSearchInputWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 15px;
  border-bottom: 1px solid #cacccb;
  border-radius: 2px;
  color: ${colorBlack900};

  &:hover {
    border-bottom: 1px solid #87928c;
  }

  ${({ focus }) =>
    focus &&
    ` 
    box-shadow: 0px 2px 0px 0px #35A47C;

  &:hover {
    box-shadow: 0px 2px 0px 0px #35A47C;
  }
  `}
`;

export const DesktopSearchInput = styled(Input)``;

export const DropdownToggle = styled.button`
  border: 1px solid #cacccb;
  border-radius: 4px;
  padding: 0 14px;
  background: #fff;
  position: relative;
  color: ${colorBlack900};
  height: 32px;
  line-height: 31px;

  &:hover {
    background: ${colorPrimaryLighten95};
    border: 1px solid #76c1a6;
  }
`;

export const TitleExtractor = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  color: ${colorBlack900};
  padding-right: 8px;
`;
